import {Component, Input, SimpleChanges} from '@angular/core';
import {ItemPlano} from "../../../../modules/cadastro/models/lista-plano";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {NovaEmpresa} from "../../../../modules/cadastro/models/nova-empresa";
import {EmpresaService} from "../../../../modules/cadastro/services/empresa.service";
import {ToastrService} from "ngx-toastr";
import {PlanoService} from "../../../../modules/cadastro/services/plano.service";
import {Router} from "@angular/router";
import {AuthService} from "../../../../modules/auth/services/auth-service";

@Component({
    selector: 'app-cadastro-formulario',
    templateUrl: './cadastro-formulario.component.html',
    styleUrl: './cadastro-formulario.component.css',
    standalone: false
})
export class CadastroFormularioComponent {
  @Input() tipoSaas = 'a9dbd402-c5fe-4aaa-93f8-ed718834d8fc';

  sucesso = false;
  cpfCnpj = true;
  planos: ItemPlano[] = [];
  formCadastrar: FormGroup;
  novoCliente = new NovaEmpresa();

  constructor(private formBuilder: FormBuilder,
              private toastr: ToastrService,
              private tokenService: AuthService,
              private planoService: PlanoService,
              private empresaService: EmpresaService) {
    this.construirFormulario();
    this.buscarListaPlanos();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['tipoSaas']) {
      this.buscarListaPlanos();
    }
  }


  private validarFormulario() {
    Object.keys(this.formCadastrar.controls).forEach(name => {
      const control = this.formCadastrar.controls[name];
      control.markAsDirty();
      control.markAsTouched();
      control.updateValueAndValidity();
    });
  }

  public salvar(){
    this.validarFormulario();
    if(this.formCadastrar.invalid){
      this.toastr.error("Formulário inválido, verifique os campos");
    }else{
      this.preencherModeloEmpresa();
      this.empresaService.novoCliente(this.novoCliente).subscribe(
        (response) => {
          if (response.sucesso) {
            this.tokenService.setAccessToken(response.dados.token);
            this.redirecionarCheckout(response.dados.url);
            this.toastr.success("Empresa salva com sucesso");
            this.sucesso = true;
          } else {
            this.toastr.error("Erro ao salvar empresa - " + response.errors[0].mensagem);
          }
        },
        (error) => {
          if(error.status === 500){
            this.toastr.error(error);
          }
          this.toastr.error(error);
        }
      );
    }
  }

  private preencherModeloEmpresa(){
    this.novoCliente.nome = this.formCadastrar.controls[`nome`].value;
    this.novoCliente.cpf = this.formCadastrar.controls[`cpf`].value;
    this.novoCliente.cnpj = this.formCadastrar.controls[`cnpj`].value;
    this.novoCliente.email = this.formCadastrar.controls[`email`].value;
    this.novoCliente.razaoSocial = this.formCadastrar.controls[`razaoSocial`].value;
    this.novoCliente.plano = this.formCadastrar.controls[`plano`].value;
    this.novoCliente.senha = this.formCadastrar.controls["senha"].value;
    this.novoCliente.confirmacaoSenha = this.formCadastrar.controls["confirmacaoSenha"].value;
    this.novoCliente.tipoSaas = this.preencherSaas();
  }

  private construirFormulario(){
    this.formCadastrar = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email, Validators.maxLength(200)]],
      senha: ['', [Validators.required, Validators.maxLength(20)]],
      confirmacaoSenha: ['', [Validators.required, Validators.maxLength(20)]],
      nome: ['', [Validators.required]],
      cpf: ['',  [Validators.required]],
      cnpj: [''],
      razaoSocial: [''],
      plano:[0]
    });
  }

  public redirecionarCheckout(url: string){
    window.location.href = url;
  }

  private preencherSaas(){
    if(this.tipoSaas === 'a9dbd402-c5fe-4aaa-93f8-ed718834d8fc')
      return 1;
    else
      return 2;
  }

  private buscarListaPlanos(){
    this.planoService.selecionarListaPorSaas(this.tipoSaas).subscribe(response => {
      if(response.sucesso)
        this.planos = response.dados.itens;
    });
  }
}
